import { NotificationPagination } from "@carnegie-learning/data-access-angular-passport";
import { Action } from "@ngrx/store";
import { Notification } from "cli-types";

// ------ Load notifications ------
export const LOAD_NOTIFICATIONS = "[Notifications] Load Notifications";
export const LOAD_NOTIFICATIONS_FAIL =
    "[Notifications] Load Notifications Fail";
export const LOAD_NOTIFICATIONS_SUCCESS =
    "[Notifications] Load Notifications Success";

export class LoadNotifications implements Action {
    readonly type = LOAD_NOTIFICATIONS;
    constructor(public payload: string) {}
}

export class LoadNotificationsFail implements Action {
    readonly type = LOAD_NOTIFICATIONS_FAIL;
    constructor(public payload: any) {}
}

export class LoadNotificationsSuccess implements Action {
    readonly type = LOAD_NOTIFICATIONS_SUCCESS;
    constructor(public payload: NotificationPagination) {}
}

// ------ Mark as read ------
export const MARK_AS_READ = "[Notifications] Mark As Read";
export const MARK_AS_READ_FAIL = "[Notifications] Mark As Read Fail";
export const MARK_AS_READ_SUCCESS = "[Notifications] Mark As Read Success";

export class MarkAsRead implements Action {
    readonly type = MARK_AS_READ;
    constructor(public payload: Notification) {}
}

export class MarkAsReadFail implements Action {
    readonly type = MARK_AS_READ_FAIL;
    constructor(public payload: any) {}
}

export class MarkAsReadSuccess implements Action {
    readonly type = MARK_AS_READ_SUCCESS;
    constructor(public payload: Notification) {}
}

// ------ Set Messages Tab ------
export const SET_MESSAGES_TAB = "[Notifications] Set Messages Tab";

export class SetMessagesTab implements Action {
    readonly type = SET_MESSAGES_TAB;
    constructor(public payload: number) {}
}

export const OPEN_MESSAGES_PANEL = "[Notifications] Open Messages Panel";
export class OpenMessagesPanel implements Action {
    readonly type = OPEN_MESSAGES_PANEL;
    constructor(public payload: boolean) {}
}

export type NotificationsAction =
    | LoadNotifications
    | LoadNotificationsFail
    | LoadNotificationsSuccess
    | MarkAsRead
    | MarkAsReadFail
    | MarkAsReadSuccess
    | SetMessagesTab
    | OpenMessagesPanel;
